import React, { useEffect, useMemo } from 'react';
import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useEvents } from './context/EventsContext';
import { useGridVirtualization } from "./hooks/useGridVirtualization";
import EventCardEPG from "./EPGEventCard";
import ChannelBanner from "./components/ChannelBanner";
import sortEvents from './utils/shared/sortEvents';
import { getModelConfig } from "../utils/models";
import { scrollIntoViewWithinContainer } from "./utils/shared/scrollIntoView";
import "./epg.scss";

const EPGFilteredEventsRow = ({ events, title, onEnterPress, shouldApplyComcastStyles, channelData, onWatchNow }) => {
    const { activeLiveContent } = useEvents();
    // Sort the filtered events
    const sortedFilteredEvents = useMemo(() => {
        return sortEvents(events, activeLiveContent);
    }, [events, activeLiveContent?.id, activeLiveContent?.contentType]);

    const { ref, focusKey, focusSelf } = useFocusable({
        focusKey: "filtered-events-container",
        onFocus: () => {
            if (ref.current) {
                if (getModelConfig().epg.customScrollBehavior) {
                    scrollIntoViewWithinContainer(ref.current, 'scrollingRows');
                } else {
                    ref.current.scrollIntoView({
                        behavior: getModelConfig().epg.scrollBehavior,
                        block: "nearest",
                        inline: "nearest",
                    });
                }
            }
        },
    });

    // Virtualize the grids
    const { containerRef, scrollingRef, containerStyle, gridStyle, virtualItems, onItemFocus } = useGridVirtualization({
        items: sortedFilteredEvents,
    });
    const renderedItems = virtualItems.map(({ item, index }) => <EventCardEPG key={item.id} event={item} index={index} rowId="filtered" onFocus={(focusProps) => onItemFocus({ ...focusProps, index })} onEnterPress={onEnterPress} />);

    useEffect(() => {
        if (sortedFilteredEvents.length > 0) {
            focusSelf();
        }
    }, [sortedFilteredEvents.length, focusSelf]);

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} className="filteredEventsRow">
                {channelData && (
                    <ChannelBanner
                        channelData={channelData}
                        onWatchNow={onWatchNow}
                    />
                )}
                <h2 className="rowTitle">{title}</h2>
                <div className="filteredEventsGrid" ref={containerRef}>
                    <div className={`eventsGridContainer ${shouldApplyComcastStyles ? 'xumo' : ''}`} ref={scrollingRef}>
                        <div style={containerStyle}>
                            <div style={gridStyle}>{renderedItems}</div>
                        </div>
                    </div>
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default EPGFilteredEventsRow;